import * as _sdk2 from "@shapediver/sdk.geometry-api-sdk-core";
var _sdk = _sdk2;
try {
  if ("default" in _sdk2) _sdk = _sdk2.default;
} catch (e) {}
import _ShapeDiverAnalyticsApi from "./resources/ShapeDiverAnalyticsApi";
import _ShapeDiverArSceneApi from "./resources/ShapeDiverArSceneApi";
import _ShapeDiverAssetApi from "./resources/ShapeDiverAssetApi";
import _ShapeDiverExportApi from "./resources/ShapeDiverExportApi";
import _ShapeDiverFileApi from "./resources/ShapeDiverFileApi";
import _ShapeDiverGltfApi from "./resources/ShapeDiverGltfApi";
import _ShapeDiverModelApi from "./resources/ShapeDiverModelApi";
import _ShapeDiverOutputApi from "./resources/ShapeDiverOutputApi";
import _ShapeDiverSdtfApi from "./resources/ShapeDiverSdtfApi";
import _ShapeDiverSessionApi from "./resources/ShapeDiverSessionApi";
import _ShapeDiverSystemApi from "./resources/ShapeDiverSystemApi";
import _ShapeDiverTextureApi from "./resources/ShapeDiverTextureApi";
import _ShapeDiverUtilsApi from "./resources/ShapeDiverUtilsApi";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeDiverSdk = void 0;
exports.create = create;
const sdk_geometry_api_sdk_core_1 = _sdk;
const ShapeDiverAnalyticsApi_1 = _ShapeDiverAnalyticsApi;
const ShapeDiverArSceneApi_1 = _ShapeDiverArSceneApi;
const ShapeDiverAssetApi_1 = _ShapeDiverAssetApi;
const ShapeDiverExportApi_1 = _ShapeDiverExportApi;
const ShapeDiverFileApi_1 = _ShapeDiverFileApi;
const ShapeDiverGltfApi_1 = _ShapeDiverGltfApi;
const ShapeDiverModelApi_1 = _ShapeDiverModelApi;
const ShapeDiverOutputApi_1 = _ShapeDiverOutputApi;
const ShapeDiverSdtfApi_1 = _ShapeDiverSdtfApi;
const ShapeDiverSessionApi_1 = _ShapeDiverSessionApi;
const ShapeDiverSystemApi_1 = _ShapeDiverSystemApi;
const ShapeDiverTextureApi_1 = _ShapeDiverTextureApi;
const ShapeDiverUtilsApi_1 = _ShapeDiverUtilsApi;
function create(baseUrl, jwt) {
  return new ShapeDiverSdk(baseUrl, jwt);
}
class ShapeDiverSdk extends sdk_geometry_api_sdk_core_1.BaseShapeDiverSdk {
  constructor(baseUrl, jwt) {
    super(baseUrl);
    if (jwt) this.setConfigurationValue(sdk_geometry_api_sdk_core_1.ShapeDiverSdkConfigType.JWT_TOKEN, jwt);
    this._analytics = new ShapeDiverAnalyticsApi_1.ShapeDiverAnalyticsApi(this.sdkApi);
    this._arScene = new ShapeDiverArSceneApi_1.ShapeDiverArSceneApi(this.sdkApi);
    this._asset = new ShapeDiverAssetApi_1.ShapeDiverAssetApi(this.sdkApi);
    this._export = new ShapeDiverExportApi_1.ShapeDiverExportApi(this.sdkApi);
    this._file = new ShapeDiverFileApi_1.ShapeDiverFileApi(this.sdkApi);
    this._gltf = new ShapeDiverGltfApi_1.ShapeDiverGltfApi(this.sdkApi);
    this._model = new ShapeDiverModelApi_1.ShapeDiverModelApi(this.sdkApi);
    this._output = new ShapeDiverOutputApi_1.ShapeDiverOutputApi(this.sdkApi);
    this._sdtf = new ShapeDiverSdtfApi_1.ShapeDiverSdtfApi(this.sdkApi);
    this._session = new ShapeDiverSessionApi_1.ShapeDiverSessionApi(this.sdkApi);
    this._system = new ShapeDiverSystemApi_1.ShapeDiverSystemApi(this.sdkApi);
    this._texture = new ShapeDiverTextureApi_1.ShapeDiverTextureApi(this.sdkApi);
    this._utils = new ShapeDiverUtilsApi_1.ShapeDiverUtilsApi(this.sdkApi);
  }
  get analytics() {
    return this._analytics;
  }
  get arScene() {
    return this._arScene;
  }
  get asset() {
    return this._asset;
  }
  get export() {
    return this._export;
  }
  get file() {
    return this._file;
  }
  get gltf() {
    return this._gltf;
  }
  get model() {
    return this._model;
  }
  get output() {
    return this._output;
  }
  get sdtf() {
    return this._sdtf;
  }
  get session() {
    return this._session;
  }
  get system() {
    return this._system;
  }
  get texture() {
    return this._texture;
  }
  get utils() {
    return this._utils;
  }
}
exports.ShapeDiverSdk = ShapeDiverSdk;
//# sourceMappingURL=ShapeDiverSdk.js.map
export default exports;